import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { json } from 'stream/consumers';

@Injectable({
  providedIn: 'root'
})
export class UserServiceClass {
  private baseUrl = environment.seApiURL;

  constructor(private http: HttpClient) { }

  signOut(accessToken:any){
    return this.http.post(this.baseUrl+'/identity-manager/logout',accessToken)
  }

}